import { ref, computed, getCurrentInstance } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { navigateNewIndexSearch } from '@/utils/newIndexSearch.js';
import { maskPhoneForDisplay } from '@/utils/utils.js';

export function useNewIndexSite() {
  const store = useStore();
  const route = useRoute();
  const router = useRouter();
  const { t } = useI18n();
  const { proxy } = getCurrentInstance();

  const showDialog = ref(false);
  const showLogin = ref(false);
  const showMobile = ref(false);

  const checkLoggedIn = () => {
    const isAuthenticated = proxy.$cookies.getAuthKey();
    const token = proxy.$cookies.getToken();
    return !!(
      isAuthenticated &&
      token !== undefined &&
      token !== '' &&
      token != null
    );
  };

  const isLoggedIn = computed(() => checkLoggedIn());

  const username = computed(() => {
    if (!checkLoggedIn()) return '';
    const info = store.state.user.userInfo || {};
    let name = t('anonymity');
    if (info.username && info.username !== 'undefined') {
      name = info.username;
    } else if (info.mobile) {
      name = info.mobile;
    }
    return maskPhoneForDisplay(name);
  });

  const onLoginDialogChange = (value) => {
    showDialog.value = value.value;
  };

  const openLogin = () => {
    sessionStorage.setItem('redirectPath', route.fullPath);
    showDialog.value = true;
    showMobile.value = false;
    showLogin.value = true;
  };

  const handleSearch = ({ query, category }) => {
    navigateNewIndexSearch(router, store, { query, category });
  };

  return {
    showDialog,
    showLogin,
    showMobile,
    isLoggedIn,
    username,
    onLoginDialogChange,
    openLogin,
    handleSearch,
  };
}
